import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * SlideActionBar: generic horizontal action bar for list items or editors.
 *
 * @param {object} params
 * @param {function():void} params.onAddAfter
 * @param {function():void} params.onDuplicate
 * @param {function():void} params.onRemove
 * @param {boolean} [params.disabled]
 */
export const SlideActionBar = ({ onAddAfter, onDuplicate, onRemove, disabled = false }) => {
    return (
        <div className="slideActionBar" role="toolbar" aria-label="Slide actions">
            <button
                type="button"
                className="action-btn"
                onClick={(e) => { e.stopPropagation(); onAddAfter && onAddAfter(); }}
                disabled={disabled}
                title="Add slide after"
            >
                <AddIcon fontSize="small" />
            </button>
            <button
                type="button"
                className="action-btn"
                onClick={(e) => { e.stopPropagation(); onDuplicate && onDuplicate(); }}
                disabled={disabled}
                title="Duplicate slide"
            >
                <ContentCopyIcon fontSize="small" />
            </button>
            <button
                type="button"
                className="action-btn danger"
                onClick={(e) => { e.stopPropagation(); onRemove && onRemove(); }}
                disabled={disabled}
                title="Delete slide"
            >
                <DeleteIcon fontSize="small" />
            </button>
        </div>
    );
};


